module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('app-header', {
    attrs: {
      "icon": "calend"
    }
  }, [_vm._v("\n        Planning\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "cols nav-planning",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    attrs: {
      "id": "prevDay"
    }
  }, [_c('strong', [_vm._v("Précédent")])]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "nextDay"
    }
  }, [_c('strong', [_vm._v("Suivant")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-full",
    staticStyle: {
      "width": "100%",
      "margin": "0 4px",
      "padding": "0 25px"
    },
    attrs: {
      "to": {
        name: 'liste-agenda'
      }
    }
  }, [_c('strong', [_vm._v("Liste")])])], 1), _vm._v(" "), [_c('calendar', {
    ref: "tuiCalendar",
    staticStyle: {
      "height": "800px"
    },
    attrs: {
      "schedules": _vm.scheduleList,
      "view": _vm.view,
      "taskView": _vm.taskView,
      "scheduleView": _vm.scheduleView,
      "theme": _vm.theme,
      "disableDblClick": _vm.disableDblClick,
      "isReadOnly": _vm.isReadOnly,
      "template": _vm.template,
      "useCreationPopup": _vm.useCreationPopup,
      "useDetailPopup": _vm.useDetailPopup
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16bf8a66","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planning/Agenda.vue
// module id = 1007
// module chunks = 0